import { Action } from '@ngrx/store';
import { Step } from '@ordersnproducts/modules/order-builder/components/cmx-stepper/cmx-stepper.component';

export enum BaseStepsActionTypes {
  UPDATE_STEPS = '[Base steps] Update base steps',
  SET_ACTIVE_STEP = '[Base steps] Set base steps',
  DISABLE_NAVIGATION = '[Base steps] Disable Navigation',
  RESET = '[Base steps] Reset',
}

export class SetActiveStep implements Action {
  readonly type = BaseStepsActionTypes.SET_ACTIVE_STEP;
  constructor(public payload: number) {}
}

export class UpdateStepsAction implements Action {
  readonly type = BaseStepsActionTypes.UPDATE_STEPS;
  constructor(public payload: Step[]) {}
}

export class DisableNavigation implements Action {
  readonly type = BaseStepsActionTypes.DISABLE_NAVIGATION;
  constructor(public payload: boolean) {}
}

export class ResetBaseSteps implements Action {
  readonly type = BaseStepsActionTypes.RESET;
  constructor(public payload: any) {}
}

export type BaseStepActions = UpdateStepsAction | SetActiveStep | DisableNavigation | ResetBaseSteps;
